import React, { useState, useEffect } from "react"
import { sidebarInfo, Images, keyCaseChange } from "../../Shared"
import { useDispatch } from "react-redux"
import { useNavigate } from "@reach/router"
import { isFloat } from "../../utils"
import { GatewayUrl } from "../../utils/config"
import axios from "axios"
import addCommas from "add-commas"
import "../../assets/css/hexMapAnalytics.css"
import { setConnectedWallet, updateUserDetailsRedux } from "../../redux/actions"
import { useLogout } from "../../hooks"

function HexMapSidebar({ sidebarKey = "base", clickHandler = () => {} }) {
  const [heatMapPopup, setheatMapPopup] = useState(false)
  const [gatewayStats, setGatewayStats] = useState(null)
  let info = sidebarInfo[sidebarKey]
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const logoutHandler = useLogout()

  useEffect(() => {
    axios
      .get(`${GatewayUrl}/fetchGatewaysStats`)
      .then(response => {
        if (response.status !== 200) throw Error("Something went wrong")
        setGatewayStats(response.data)
      })
      .catch(error => {
        if (!error.response) return
        if (error?.response?.status === 401) {
          logoutHandler()
        }
      })
  }, [])

  if (!info) return null

  return (
    <div className="heatmap-bar">
      {/* <div className="logo"> */}
      <div className="logo">
        <a href="/">
          <img src={Images.Logo} alt="Nitro Logo" />
        </a>
      </div>
      {/* </div> */}

      <div
        className={
          heatMapPopup
            ? "heatmap-content show-mobile-version"
            : "heatmap-content"
        }>
        <div className="heatmap-text">
          <div className="hide-on-desktop f">
            <h2>
              Welcome to Nitro <br /> Explorer
            </h2>
            {/* Cross icon here */}
            <p onClick={() => setheatMapPopup(false)}>X</p>
          </div>
          <p>
            Participants of Nitro’s decentralized PCN are part of an inclusive
            ecosystem that they own, operate and earn.
          </p>
        </div>

        <div className="heatmap-data-boxes">
          {gatewayStats
            ? Object.entries(gatewayStats).map(([key, value], index) => (
                <a
                  href="#"
                  key={key + index}
                  className="heatmap-box"
                  // className={`heatmap-box${
                  //   detail.key === sidebarKey ? " active" : ""
                  // }`}
                >
                  <p className="light small">{keyCaseChange(key)}</p>
                  <div className="flex-between">
                    <h5>
                      {Number.isNaN(value) || !isFloat(value)
                        ? value
                        : addCommas(value)}
                    </h5>

                    <p
                    // onClick={() => clickHandler(detail.key)}
                    >
                      {" "}
                      {">"}{" "}
                    </p>
                  </div>
                </a>
              ))
            : null}
        </div>
      </div>
      {/* Only For Mobile View */}
      <div className="heat-mobile-view" onClick={() => setheatMapPopup(true)}>
        <button>Analytics</button>
      </div>
    </div>
  )
}

export default HexMapSidebar
